import styled from "styled-components";

export const Container = styled.div`
  background-color: #1a3458;
  position: fixed;
  height: 100%;
  top: 0px;
  right: ${(props) => (props.$sidebar ? "0" : "-100%")};
  width: 320px;
  animation: showSidebar 0.4s;
  z-index: 1;

  img {
    margin-top: 35px;
    margin-right: 20px;
    right: 0px;
    position: fixed;
    cursor: pointer;
  }

  @keyframes showSidebar {
    from {
      width: 0;
    }
    to {
      width: 320px;
    }
  }
`;

export const Content = styled.div`
  margin-top: 100px;
  height: 500px;
  padding: 20px;

  ul {
    list-style-type: none;
    color: white;
    gap: 20px;
    display: flex;
    flex-direction: column;
  }
`;
